// app/javascript/recaptcha_bridge.js
// Global functions referenced by reCAPTCHA callbacks.
// Each dispatches a bubbling event so Stimulus controllers can listen on the form.

// Charity Partner form
window.onPartnerCaptchaSuccess = function (token) {
    const form = document.getElementById("charity-partner-form")
    if (form) {
        form.dispatchEvent(
            new CustomEvent("captcha:success", {
                detail: { token },
                bubbles: true
            })
        )
    }
}

// Find a Party form (new)
window.onFindPartyCaptchaSuccess = function (token) {
    const form = document.getElementById("find-party-form")
    if (form) {
        form.dispatchEvent(
            new CustomEvent("captcha:success", {
                detail: { token },
                bubbles: true
            })
        )
    }
}

// Unsubscribe
window.onUnsubCaptchaSuccess = function (token) {
    const form = document.getElementById("unsubscribe-form")
    if (form) {
        form.dispatchEvent(
            new CustomEvent("captcha:success", {
                detail: { token },
                bubbles: true
            })
        )
    }
}